import { apiUri } from "../../../config";
import axios from "axios";
import { padCalendar } from "../../../util";

export const LOAD_CASES = 'LOAD_CASES';


const receivedPageOfCases = (cases, page) => {

    const convertedCases = cases.content.map(c => {
        c.dateFiled = padCalendar(c.dateFiled);
        c.classPeriodStart = padCalendar(c.classPeriodStart);
        c.classPeriodEnd = padCalendar(c.classPeriodEnd);
        return {
            fillingName: c.caseName,
            fillingDate: c.dateFiled,
            classPeriodStart: c.classPeriodStart,
            classPeriodEnd: c.classPeriodEnd,
            ticker: c.symbol,
            caseId: c.caseId,
            purchased: c.purchased,
            docketId: c.docketId,
            issCaseId: c.issCaseId,
            sicCode: c.sicCode,
            cik: c.cik,
            market: c.market,
            docketNotes: c.docketNotes,
            nextTradingDay: c.nextTradingDay,
            settlementValue:c.settlementValue,
            enabled: c.enabled,
            identifier: c.identifier,
            caseRuleTypeId: c.caseRuleTypeId,
            settlementStatusId:c.settlementStatusId,
            indexListId:c.indexListId,
            caseRuleType: c.caseRuleType,
            caseFile: c.caseFile,
            complaintFile: c.complaintFile,
            amendClaims: c.amendClaims,
            amendClaimsOrig: c.amendClaims,
            amendClaimsType: c.amendClaimsType,
			blockIssUpdates: c.blockIssUpdates,
			importStatus: !c.importStatus,
			s3URL: c.s3URL,
			companyId: c.companyId
        }
    }
    );
    return ({
        type: LOAD_CASES,
        cases: convertedCases,
        totalCases: cases.total,
        totalPages: cases.totalPages,
        currentPage: page
    })
};


export const searchAdminData = (page) => {
    
    let pageNo = page;
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    var search = '';
    if (searchData) {
        search = searchData;
    }
    return dispatch => {

        axios.get(apiUri + "/cases/admin?page=" + pageNo + "&search=" + search + "&sortField=&order=")
            .then(json => dispatch(receivedPageOfCases(json.data, page)))
            .catch(err => { console.log(err) })
    }
};
export const searchSortAdminData = (page=0, sortKey='', sortOrder='') => {
   
    let pageNo = page;
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    var search = '';
    if (searchData) {
        search = searchData;
    }
    return dispatch => {

        axios.get(apiUri + "/cases/admin?page=" + pageNo + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
            .then(json => dispatch(receivedPageOfCases(json.data, page)))
            .catch(err => { console.log(err) })
    }
};


export const requestPageOfAdminCases = (page=0, sortKey='', sortOrder='') => {
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    let sortData = JSON.parse(localStorage.getItem("sortParams"));

    var search = '';
    sortKey = '';
    sortOrder = '';
    if (searchData) {
        search = searchData;
    }
    if (sortData) {
        sortKey = sortData.sortValue;
        sortOrder = sortData.sortOrder;
    }
    return dispatch => {

        axios.get(apiUri + "/cases/admin?page=" + page + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
            .then(json => {
                dispatch(receivedPageOfCases(json.data, page))
            })
            .catch(err => { console.log(err) })
    }
};


// WEBPACK FOOTER //
// ./src/components/Admin/store/action.js